import React from 'react'
import { Box, Button, Checkbox, Chip, Divider, Typography } from '@mui/material';
import PreviewImage from '../../../../../components/preview-image/PreviewImage';
import FavoriteIcon from '@mui/icons-material/Favorite';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import moment from 'moment';
import { colors } from '../../../../../constants/colors';

import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import LocalMallOutlinedIcon from '@mui/icons-material/LocalMallOutlined';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import BookSlide from '../../element/BooksViewList';
import { createSearchParams, useNavigate } from 'react-router-dom';
import Hashids from 'hashids';
import { routeName } from '../../../../../routes/routeName';
import { LIBRARY_HEAD_STATUS, LIBRARY_LIKE } from '../../../enum/elibrary_enum';
import LocalMallIcon from '@mui/icons-material/LocalMall';
import { globalLikeBookmark } from '../../element/global_like_func';
import { formatFileSize } from '../../../../../utils/app.utils';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import DownloadIcon from '@mui/icons-material/Download';
import clsx from 'clsx';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import VideoPlayer from '../../../../../components/video-player/VideoPlayer';
import { useTranslation } from 'react-i18next';
import i18n from '../../../../../i18n';


type Props = {
    img_url: string;
    callback?: () => void;
    full_width?: boolean;
    is_ebook_or_other?: {
        file_size: number;
        file_type: string;
        total_page?: string;
    },
    is_video_url?: boolean;
    show_column?: boolean;
    hidden_borrow?: boolean;
    hidden_sales?: boolean;
    hidden_sales_count?: boolean;
    total_download?: string;
    path_view_all?: string;
    path_other_content?: string;
    language_content?: React.ReactNode;
    data: {
        checkedLike?: boolean;
        setCheckedLike?: (status: boolean) => void;
        title: string;
        author: string;
        library_head_types: { name: string }[];
        library_author_by: string;
        library_category_desc: string;
        remaining_stock: string;
        remaining_stock_rent: string;
        remaining_stock_rent_out: boolean;
        library_page: number;
        price_amount: number;
        waiting_line: string;
        rent_count: number;
        like_count: number;
        sold_count: number;
        like?: number;
        date?: string;
        button_example?: {
            enable: boolean;
            text: string;
            icon?: React.ReactNode;
            onClick?: () => void;
            disabled?: boolean;
        };
        button_rent?: {
            enable: boolean;
            text: string;
            icon?: React.ReactNode;
            onClick?: () => void;
        };
        button_rent_success?: {
            enable: boolean;
            text: string;
            icon?: React.ReactNode;
            disabled?: boolean;
            onClick?: () => void;
        };
        button_booked?: {
            enable: boolean;
            text: string;
            disabled?: boolean;
            icon?: React.ReactNode;
            onClick?: () => void;
        };
        button_buy?: {
            enable: boolean;
            text: string;
            icon?: React.ReactNode;
            onClick?: (e: any) => void;
        },
        button_read?: {
            enable: boolean;
            text: string;
            icon?: React.ReactNode;
            onClick?: () => void;
            disabled?: boolean;
        },
        button_return?: {
            enable: boolean;
            text: string;
            icon?: React.ReactNode;
            onClick?: () => void;
        },
        button_view?: {
            enable: boolean;
            text: string;
            icon?: React.ReactNode;
            onClick?: () => void;
        },
        button_download?: {
            enable: boolean;
            text: string;
            icon?: React.ReactNode;
            onClick?: () => void;
            disabled?: boolean;
        },
    }
    ref_data: { author: string, img_url: string, id_library_head: number, title: string, library_head_status: string, is_like?: boolean, is_bookmark?: boolean }[];
}

const BoxBookDetail: React.FC<Props> = (props: Props) => {
    const { t } = useTranslation();
    const { data,
        ref_data,
        full_width = true,
        language_content,
        show_column,
        is_video_url,
        path_other_content = routeName.e_library.books_detail,
        is_ebook_or_other,
        path_view_all = routeName.e_library.books_list,
        hidden_sales_count
    } = props;
    const navigate = useNavigate();
    const hash_ids = new Hashids(process.env.REACT_APP_SECRET_SALT, 50);


    return (
        <Box sx={{ margin: "0 auto", maxWidth: { xs: "100%", xl: full_width ? "100%" : "844px" } }}>
            <Box className={show_column ? "flex flex-col gap-6" : "flex flex-col xl:flex-row gap-6"} component={"section"}>
                <Box minWidth={406} component={"article"} sx={{
                    height: "clamp(500px, 22vw, 575px)",
                    borderRadius: "1rem",
                }} className={show_column ? "w-full border-2 rounded-[8px] overflow-hidden" : "max-w-[406px] border-2 rounded-[8px] overflow-hidden"}>
                    {is_video_url ? (
                        <VideoPlayer
                            src={props.img_url}
                        />
                    ) : (
                        <PreviewImage
                            disable_show={false}
                            image_url={props.img_url}
                            disabled_max_width
                            render_image={
                                <img className='object-cover w-full h-full'
                                    src={props.img_url}
                                    alt={data.title}
                                    loading='lazy'
                                />
                            }
                        />
                    )}
                </Box>
                <Box component={"article"}>
                    <Typography fontWeight={800} sx={{ fontSize: "clamp(18px,10vw,28px)" }} variant='h4'>
                        {data.title}
                    </Typography>
                    <Typography mt={1}>
                        {t("โดย :")} {data.author}
                    </Typography>
                    <Box my={1} className="flex gap-4">
                        <span className="flex gap-2 justify-start items-center">
                            {/* <Checkbox
                                sx={{ p: 0 }}
                                checkedIcon={<FavoriteIcon sx={{ color: 'red' }} />}
                                icon={<FavoriteIcon sx={{ color: 'rgba(0,0,0,.5)' }} />}
                                checked={data.checkedLike}
                                onChange={(e) => data.setCheckedLike?.(e.target.checked)}
                            /> */}
                            <Typography>{t("จำนวนการกดถูกใจ")}</Typography>
                            <Typography>{data?.like_count || "0"}</Typography>
                        </span>
                        <span className="flex gap-2 justify-start items-center">
                            <AccessTimeIcon />
                            {data.date && (
                                <Typography>{moment(data.date).add(i18n.language === "en" ? 0 : 543, 'year').locale(i18n.language === "en" ? "en" : "th").format("LL")}</Typography>
                            )}
                        </span>
                    </Box>
                    <Box my={2} className="flex flex-col xl:flex-row flex-wrap gap-2">
                        {data.button_read?.enable && (
                            <Button
                                disabled={data?.button_read?.disabled}
                                onClick={data.button_read.onClick}
                                startIcon={data.button_read.icon || <RemoveRedEyeOutlinedIcon />}
                                sx={{ flex: { xs: undefined, xl: 1 }, borderRadius: "8px", border: '1px solid #000', color: colors.textNormal }} variant='outlined'>
                                {data.button_read.text}
                            </Button>
                        )}
                        {data.button_return?.enable && (
                            <Button
                                onClick={data.button_return.onClick}
                                startIcon={data.button_return.icon || <LocalMallIcon />}
                                sx={{ flex: { xs: undefined, xl: 1 } }} color='error' variant='contained'>
                                {data.button_return.text}
                            </Button>
                        )}
                        {data.button_example?.enable && (
                            <Button
                                disabled={data?.button_example?.disabled}
                                onClick={data.button_example.onClick}
                                startIcon={data.button_example.icon || <RemoveRedEyeOutlinedIcon />}
                                sx={{ flex: { xs: undefined, xl: 1 }, borderRadius: "8px", border: '1px solid #000', color: colors.textNormal }} variant='outlined'>
                                {data.button_example.text}
                            </Button>
                        )}
                        {data.button_rent?.enable && (
                            <Button
                                onClick={data.button_rent.onClick}
                                startIcon={data.button_rent.icon || <LocalMallOutlinedIcon />}
                                sx={{ flex: { xs: undefined, xl: 1 }, borderRadius: "8px" }} variant='contained' color='secondary'>
                                {data.button_rent.text}
                            </Button>
                        )}
                        {data.button_buy?.enable && (
                            <Button
                                onClick={data.button_buy.onClick}
                                startIcon={data.button_buy.icon || <ShoppingCartOutlinedIcon />}
                                sx={{ flex: { xs: undefined, xl: 1 }, borderRadius: "8px" }} variant='contained' color='success'>
                                {data.button_buy.text}
                            </Button>
                        )}
                        {data.button_view?.enable && (
                            <Button
                                onClick={data.button_view.onClick}
                                startIcon={data.button_view.icon || <VisibilityOutlinedIcon />}
                                sx={{ flex: { xs: undefined, xl: 1 }, borderRadius: "8px" }} variant='outlined'>
                                {data.button_view.text}
                            </Button>
                        )}
                        {data.button_download?.enable && (
                            <Button
                                onClick={data.button_download.onClick}
                                disabled={data.button_download.disabled}
                                startIcon={data.button_download.icon || <DownloadIcon />}
                                sx={{ flex: { xs: undefined, xl: 1 }, borderRadius: "8px" }} variant='contained' color='success'>
                                {data.button_download.text}
                            </Button>
                        )}
                        {data.button_rent_success?.enable && (
                            <Button
                                onClick={data.button_rent_success.onClick}
                                disabled={data.button_rent_success.disabled}
                                startIcon={data.button_rent_success.icon || <ShoppingBagIcon />}
                                sx={{ flex: { xs: undefined, xl: 1 }, borderRadius: "8px" }} variant='contained' color='success'>
                                {data.button_rent_success.text}
                            </Button>
                        )}
                        {data.button_booked?.enable && (
                            <Button
                                onClick={data.button_booked.onClick}
                                disabled={data.button_booked.disabled}
                                startIcon={data.button_booked.icon || <ShoppingBagIcon />}
                                sx={{ flex: { xs: undefined, xl: 1 }, borderRadius: "8px" }} variant='contained' color='secondary'>
                                {data.button_booked.text}
                            </Button>
                        )}
                    </Box>
                    {!props.hidden_borrow && (
                        <>
                            <Box my={3} className="grid grid-cols-12 gap-4">
                                {!hidden_sales_count && (
                                    <Box className={clsx("col-span-12 md:col-span-4 flex justify-center items-center flex-col", {
                                    })}>
                                        <Typography textAlign={"center"}>
                                            {t("คงเหลือจำหน่าย")}
                                        </Typography>
                                        <Typography variant='h5' sx={{ color: "#F79009" }} textAlign={"center"}>
                                            {data?.remaining_stock || "-"}
                                        </Typography>
                                    </Box>
                                )}
                                <Box className={clsx("col-span-12 md:col-span-4 flex justify-center items-center flex-col", {

                                })}>
                                    <Typography textAlign={"center"}>
                                        {t("คงเหลือให้ยืม")}
                                    </Typography>
                                    <Typography variant='h5' sx={{ color: "#F79009" }} textAlign={"center"}>
                                        {data?.remaining_stock_rent || "-"}
                                    </Typography>
                                </Box>
                                <Box className={clsx("col-span-12 md:col-span-4 flex justify-center items-center flex-col", {

                                })}>
                                    <Typography textAlign={"center"}>
                                        {t("ยืมแล้ว")}
                                    </Typography>
                                    <Typography variant='h5' sx={{ color: "#F79009" }} textAlign={"center"}>
                                        {data?.rent_count ?? "-"}
                                    </Typography>
                                </Box>
                            </Box>
                            <Typography textAlign={"center"} sx={{ color: "#828282" }} my={2}>
                                {t("พร้อมให้ยืมในอีกประมาณ")} {data?.waiting_line || "0"} {data?.waiting_line ? "" : t("วัน")}
                            </Typography>
                            <Divider
                                flexItem
                                sx={{
                                    borderBottomWidth: 2,
                                    borderColor: "grey.300",
                                    borderStyle: "dashed",
                                }}
                            />

                        </>
                    )}
                    {!props.hidden_sales && (
                        <Box my={3} className="grid grid-cols-12 gap-4">
                            <Box className={clsx("col-span-12 md:col-span-4 flex justify-center items-center flex-col", {

                            })}>
                                <Typography textAlign={"center"}>
                                    {t("จำนวนหน้า")}
                                </Typography>
                                <Typography variant='h5' sx={{ color: "#F79009" }} textAlign={"center"}>
                                    {data?.library_page || "-"}
                                </Typography>
                            </Box>
                            <Box className={clsx("col-span-12 md:col-span-4 flex justify-center items-center flex-col", {

                            })}>
                                <Typography textAlign={"center"}>
                                    {t("ราคา")}
                                </Typography>
                                <Typography
                                    variant="h5"
                                    sx={{ color: "#F79009" }}
                                    textAlign="center"
                                >
                                    {Math.abs(Number(data?.price_amount || "0")).toLocaleString(undefined, {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                    })} B
                                </Typography>
                            </Box>
                            <Box className={clsx("col-span-12 md:col-span-4 flex justify-center items-center flex-col", {

                            })}>
                                <Typography textAlign={"center"}>
                                    {t("จำหน่ายแล้ว")}
                                </Typography>
                                <Typography variant='h5' sx={{ color: "#F79009" }} textAlign={"center"}>
                                    {data?.sold_count ?? "-"}
                                </Typography>
                            </Box>
                        </Box>
                    )}
                    {is_ebook_or_other && (
                        <Box my={3} className="grid grid-cols-12 gap-4">
                            <Box className={clsx("col-span-12 md:col-span-4 flex justify-center items-center flex-col", {

                            })}>
                                <Typography textAlign={"center"}>
                                    {t("ขนาดไฟล์")}
                                </Typography>
                                <Typography variant='h5' sx={{ color: "#F79009" }} textAlign={"center"}>
                                    {formatFileSize(is_ebook_or_other.file_size)}
                                </Typography>
                            </Box>
                            <Box className={clsx("col-span-12 md:col-span-4 flex justify-center items-center flex-col", {

                            })}>
                                <Typography textAlign={"center"}>
                                    {t("รูปแบบไฟล์")}
                                </Typography>
                                <Typography variant='h5' sx={{ color: "#F79009", textTransform: "uppercase" }} textAlign={"center"}>
                                    {is_ebook_or_other.file_type}
                                </Typography>
                            </Box>
                            {is_ebook_or_other?.total_page && (
                                <Box className={clsx("col-span-12 md:col-span-4 flex justify-center items-center flex-col", {

                                })}>
                                    <Typography textAlign={"center"}>
                                        {t("จำนวนหน้า")}
                                    </Typography>
                                    <Typography variant='h5' sx={{ color: "#F79009" }} textAlign={"center"}>
                                        {is_ebook_or_other?.total_page || "-"}
                                    </Typography>
                                </Box>
                            )}
                        </Box>
                    )}

                    {language_content && (
                        <>
                            <Divider
                                flexItem
                                sx={{
                                    my: 1,
                                    borderBottomWidth: 2,
                                    borderColor: "grey.300",
                                    borderStyle: "dashed",
                                }}
                            />
                            {language_content}
                        </>
                    )}

                    <Divider
                        flexItem
                        sx={{
                            borderBottomWidth: 2,
                            borderColor: "grey.300",
                            borderStyle: "dashed",
                        }}
                    />

                    {props.total_download && (
                        <>
                            <Box my={3} className="grid grid-cols-12 gap-4">
                                <Box className={clsx("col-span-12 md:col-span-4 flex justify-center items-center flex-col", {

                                })}>
                                    <Typography textAlign={"center"}>
                                        {t("ยอดดาวน์โหลด")}
                                    </Typography>
                                    <Typography variant='h5' sx={{ color: "#F79009" }} textAlign={"center"}>
                                        {props.total_download}
                                    </Typography>
                                </Box>
                            </Box>
                            <Divider
                                flexItem
                                sx={{
                                    borderBottomWidth: 2,
                                    borderColor: "grey.300",
                                    borderStyle: "dashed",
                                }}
                            />
                        </>
                    )}

                    <Box my={2} className="flex w-full flex-wrap gap-4">
                        {data?.library_head_types?.map((list) => {
                            return (
                                <Chip
                                    label={list.name || ""}
                                />
                            )
                        })}
                    </Box>

                    <Typography>
                        {t("สำนักพิมพ์ :")} {data?.library_author_by || "-"}
                    </Typography>
                </Box>
            </Box>

            <Box mt={4}>
                <Typography variant='h5'>
                    {t("เรื่องย่อ")}
                </Typography>
                <Typography>
                    {data.library_category_desc || "-"}
                </Typography>
            </Box>

            <Box className="col-span-12" mt={4}>
                <Typography variant='h5'>
                    {t("หนังสือที่เกี่ยวข้อง")}
                </Typography>
                {ref_data?.length > 0 ? <Box sx={{ width: "100%" }}>
                    <BookSlide
                        title=""
                        subtitle=""
                        is_recommend
                        onViewAll={() => navigate({ pathname: path_view_all, search: createSearchParams({ status: LIBRARY_HEAD_STATUS.ALL }).toString() })}
                        viewAllButton={
                            <Button onClick={() => navigate({ pathname: path_view_all, search: createSearchParams({ status: LIBRARY_HEAD_STATUS.ALL }).toString() })} startIcon={< RemoveRedEyeOutlinedIcon />} sx={{ color: colors.textNormal }}>
                                {t("ดูทั้งหมด")}
                            </Button>
                        }
                        data={ref_data?.map((list) => {
                            const is_news = list?.library_head_status === LIBRARY_HEAD_STATUS.NEW;
                            return {
                                onClick: () => {
                                    const encode_id = hash_ids.encode(String(list.id_library_head || ""));
                                    navigate({
                                        pathname: path_other_content.replace(":id", encode_id), search: createSearchParams({
                                            status: is_news ? LIBRARY_HEAD_STATUS.NEW : LIBRARY_HEAD_STATUS.POPULAR
                                        }).toString()
                                    }, {
                                        replace: true
                                    })
                                },
                                checkedLike: !!list?.is_like,
                                checkedBookmark: !!list?.is_bookmark,
                                setCheckedBookmark: async () => {
                                    await globalLikeBookmark(list?.id_library_head, LIBRARY_LIKE.BOOKMARK);
                                    props.callback?.();
                                },
                                setCheckedLike: async () => {
                                    await globalLikeBookmark(list?.id_library_head, LIBRARY_LIKE.LIKE);
                                    props.callback?.();
                                },
                                book_name: list?.author || "",
                                book_sub_name: list?.author || "",
                                id: list?.id_library_head,
                                img_url: list.img_url
                            }
                        })}
                    />
                </Box> : <>
                    <Typography>{t("ไม่พบข้อมูล...")}</Typography>
                </>}
            </Box>
        </Box >
    )
}

export default BoxBookDetail